import dayjs from 'dayjs';
import React from 'react';
import { Dropdown } from 'rsuite';
import { RSuiteDropdownStyler } from '../styles';

const last12Months = 'Last 12 Months';
const historicYearsToDisplay = 3;

interface Props {
  selected: number;
  onSelect: React.Dispatch<React.SetStateAction<number>>;
  disabled: boolean;
}

export function TimeFrameDropdown(props: Props): React.ReactElement {
  const availableTimeFrames: number[] = Array.from(
    // Add one to include the current year
    Array(historicYearsToDisplay + 1),
    (_, index) => dayjs().year() - index
  );

  return (
    <RSuiteDropdownStyler width="150px">
      <Dropdown
        data-testid="property-tax-reporting-time-frame-dropdown"
        title={
          dayjs().isSame(String(props.selected), 'year')
            ? last12Months
            : props.selected
        }
        onSelect={props.onSelect}
        disabled={props.disabled}
      >
        {availableTimeFrames.map((timeFrame) => (
          <Dropdown.Item key={timeFrame} eventKey={timeFrame}>
            {dayjs().isSame(String(timeFrame), 'year')
              ? last12Months
              : timeFrame}
          </Dropdown.Item>
        ))}
      </Dropdown>
    </RSuiteDropdownStyler>
  );
}
